<template>
  <div class="active-active-loader__spinner">
    <div class="active-loader__spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'ActiveLoader',
};
</script>

<style scoped>
.active-active-loader__spinner {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  border: 1px solid #198754;
}

.active-loader__spinner {
  width: 4px;
  height: 30px;
  border-radius: 4px;
  display: block;
  margin: 20px auto;
  position: relative;
  background: currentColor;
  color: #fff;
  box-sizing: border-box;
  animation: animloader 0.3s 0.3s linear infinite alternate;
}

.active-loader__spinner::after,
.active-loader__spinner::before {
  content: '';
  width: 6px;
  height: 30px;
  border-radius: 4px;
  background: currentColor;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
  box-sizing: border-box;
  animation: animloader 0.3s 0.45s linear infinite alternate;
}
.active-loader__spinner::before {
  left: -20px;
  animation-delay: 0s;
}

@keyframes animloader {
  0% {
    height: 48px;
  }
  100% {
    height: 4px;
  }
}
</style>
